import { render } from "./time-span-calculator.vue?vue&type=template&id=6a8bcdc3&scoped=true"
import script from "./time-span-calculator.vue?vue&type=script&lang=js"
export * from "./time-span-calculator.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a8bcdc3"

export default script